'use client';

import { c as _c } from "react/compiler-runtime";
import { SpendOverTimeLegend, SpendPerTaskOverTimeChart, TotalSpendOverTimeChart } from '@/domains/pages/ai-spend/components/spend-over-time-chart';
import { SpendChartModeTabs } from '@/domains/pages/ai-spend/components/spend-chart-mode-tabs';
import { SPEND_OVER_TIME_CARD_TITLE, SPEND_OVER_TIME_CARD_TOOLTIP, SPEND_OVER_TIME_CHART_MIN_HEIGHT_CLASS, type SpendChartMode } from '@/domains/pages/ai-spend/constants';
import type { SpendPeerBandPoint } from '@/domains/pages/ai-spend/utils/map-ai-spend-segment-trend';
import { NebulyPageCard } from '@/domains/pages/shared/nebuly-page-card';
import { cn } from '@/utils/shad';
type AiSpendOverTimeCardProps = {
  mode: SpendChartMode;
  onModeChange: (mode: SpendChartMode) => void;
  labels: string[];
  totalSpend: Array<number | null>;
  spendPerTask: Array<number | null>;
  peerBand?: SpendPeerBandPoint[];
  seriesLabel?: string;
  avgSpendPerTask?: Array<number | null>;
  avgLineLabel?: string;
  segmentNoun?: string;
  testId?: string;
};
export function AiSpendOverTimeCard(t0) {
  const $ = _c(27);
  const {
    mode,
    onModeChange,
    labels,
    totalSpend,
    spendPerTask,
    peerBand,
    seriesLabel,
    avgSpendPerTask,
    avgLineLabel,
    segmentNoun,
    testId
  } = t0;
  let t1;
  if ($[0] !== mode || $[1] !== onModeChange) {
    t1 = <SpendChartModeTabs value={mode} onValueChange={onModeChange} />;
    $[0] = mode;
    $[1] = onModeChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== avgLineLabel || $[4] !== mode || $[5] !== peerBand || $[6] !== segmentNoun || $[7] !== seriesLabel) {
    t2 = <SpendOverTimeLegend mode={mode} peerBand={peerBand} segmentNoun={segmentNoun} seriesLabel={seriesLabel} avgLineLabel={avgLineLabel} className="mb-4 shrink-0" />;
    $[3] = avgLineLabel;
    $[4] = mode;
    $[5] = peerBand;
    $[6] = segmentNoun;
    $[7] = seriesLabel;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("h-full flex-1", SPEND_OVER_TIME_CHART_MIN_HEIGHT_CLASS);
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== avgLineLabel || $[11] !== avgSpendPerTask || $[12] !== labels || $[13] !== mode || $[14] !== peerBand || $[15] !== segmentNoun || $[16] !== seriesLabel || $[17] !== spendPerTask || $[18] !== totalSpend) {
    t4 = <div className={t3}>{mode === "total" ? <TotalSpendOverTimeChart labels={labels} totalSpend={totalSpend} /> : <SpendPerTaskOverTimeChart labels={labels} spendPerTask={spendPerTask} peerBand={peerBand} seriesLabel={seriesLabel} avgSpendPerTask={avgSpendPerTask} avgLineLabel={avgLineLabel} segmentNoun={segmentNoun} />}</div>;
    $[10] = avgLineLabel;
    $[11] = avgSpendPerTask;
    $[12] = labels;
    $[13] = mode;
    $[14] = peerBand;
    $[15] = segmentNoun;
    $[16] = seriesLabel;
    $[17] = spendPerTask;
    $[18] = totalSpend;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== t2 || $[21] !== t4) {
    t5 = <div className="flex min-h-0 flex-1 flex-col">{t2}{t4}</div>;
    $[20] = t2;
    $[21] = t4;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== t1 || $[24] !== t5 || $[25] !== testId) {
    t6 = <NebulyPageCard title={SPEND_OVER_TIME_CARD_TITLE} description={SPEND_OVER_TIME_CARD_TOOLTIP} fillHeight={true} className="min-h-0 flex-1" contentClassName="flex min-h-0 flex-1 flex-col" testId={testId} headerTrailing={t1}>{t5}</NebulyPageCard>;
    $[23] = t1;
    $[24] = t5;
    $[25] = testId;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  return t6;
}